module.exports = __webpack_public_path__ + "static/img/produce03.ce2e0fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/produce03.png
// module id = 133
// module chunks = 4